export default __webpack_public_path__ + "static/media/8.5011dd9a.png";